import { render, staticRenderFns } from "./home-trainers-saying.vue?vue&type=template&id=02fe3fb1&scoped=true&"
import script from "./home-trainers-saying.vue?vue&type=script&lang=js&"
export * from "./home-trainers-saying.vue?vue&type=script&lang=js&"
import style0 from "./home-trainers-saying.vue?vue&type=style&index=0&id=02fe3fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe3fb1",
  null
  
)

export default component.exports